/**
 * This component renders the game centre schedule
 * WARNING - Currently using dummy data, not connected to API
 */
import React from "react";
import Schedule from "../core/Schedule";
import {useQuery} from "@tanstack/react-query";
import Loading from "../core/Loading";
import {allSeasons} from "../utils/time";

const Component = (offset) => {
  const { isLoading, error, data} = useQuery({
    staleTime: Infinity,
    queryKey: ['clubs'],
    queryFn: () =>
        fetch(`${process.env.REACT_APP_BUIHA_API_URL}/club/all/`).then((res) =>
            res.json(),
        ),
  });

  if (isLoading)
    return (
      <Loading />
    );
    

  if (error) return 'An error has occurred: ' + error.message;

  data && data.sort((a, b) => (a.name > b.name ? 1 : -1));

  const parseClubs = (clubData) => {
    const clubsArray = [];
    clubData.map((club) => {
      if (club.status === "Active") clubsArray.push(club);
    });
    return clubsArray;
  }

  return (
    // Container for all pages
    <Schedule 
      mode="all"
      sidebar={null}
      teams={[]}
      clubs={parseClubs(data)}
      id={0}
      season_offset={offset.offset}
      seasons={allSeasons()}
    />
  );
}
export default Component;